import * as React from 'react';
import styles from './index.scss';
import animatedArrow from './animated-arrow.png';

export function ArrowButton() {
  return (
    <div id="arrow-btn" data-zone="arrow_button" className={styles.arrowButton}>
      <img src={animatedArrow} className={styles.arrowIcon} alt="click" />
    </div>
  );
}
